import Vue from 'vue';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import VueI18Next from '@panter/vue-i18next';
import { APP_COMPANY_NAME } from '../environment';
import 'url-search-params-polyfill';

const urlParameters = new URLSearchParams(window.location.search);
const languageCode = urlParameters.get('language');

let i18nextOptions = {
  fallbackLng: {
    default: ['en'],
  },
  debug: false,
  lowerCaseLng: true,
  ns: ['translation', 'common'],
  backend: {
    loadPath: 'locales/{{lng}}/{{ns}}.json',
  },
};

if (languageCode) {
  i18nextOptions['lng'] = languageCode;
}

Vue.use(VueI18Next);

if (APP_COMPANY_NAME === 'genentech') {
  i18nextOptions['lng'] = 'en';

  i18next.use(Backend).init(i18nextOptions);
} else {
  i18next.use(Backend).use(LanguageDetector).init(i18nextOptions);
}

export const i18n = new VueI18Next(i18next);

export default i18n;
